<template>
   <section class='section'>
        <h3>{{title}}</h3>
        <div class='card'>
            <slot></slot>
        </div>
    </section>
</template>

<script>


export default {
  name: "BtnNav",
  props: ['title'],
  components: {},
  data() {
    return {

    }
  },
  mounted() {},
  created() {},
  firestore() {
    return {};
  },
  methods: {},
  watch: {}
};
</script>

<style lang="scss">
    .section {
        margin-top: 50px;

        h3 {
            margin-bottom: 10px;
        }

        .card {
            background: #f7f7f7;
            padding: 30px;
        }

        .inputs {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;

            .input {
                width: 48%;
                display: flex;
                flex-direction: column;
                margin-bottom: 20px;

                @media screen and (max-width: 600px){
                    width: 100%;
                }

                &.full {
                    width: 100%;
                }

                label {
                    margin-bottom: 5px;
                    opacity: .5;

                    span {
                        color: #FBA500;
                    }
                }

                textarea {
                    max-width: 100%;
                    min-width: 100%;
                    max-height: 300px;
                }

                input, textarea {
                    background-color: white;
                    border: none;
                    outline: none;
                    padding: 10px 15px;
                    font-size: 17px;
                    color: #0D0D0D;
                    width: 100%;
                    box-shadow: 0 0 8px rgba(128, 128, 128, 0.20);

                    &.half {
                        width: 40%;
                        min-width: 200px;
                    }
                }
            }
        }

    }
</style>
